export default class Analytics {
    static SIGN_UP = "sign_up";
    static AI_INTAKE_DOWNLOAD_BRIEF = "ai_intake_download_brief";
    static AI_INTAKE_OPEN = "ai_intake_open";
    static AI_INTAKE_RESET_BRIEF = "ai_intake_reset_brief";
    static AI_INTAKE_CREATE_PROJECT = "ai_intake_create_project";
    static AI_INTAKE_CREATE_BID = "ai_intake_create_bid";

    static labels = {
        [Analytics.AI_INTAKE_DOWNLOAD_BRIEF]: "AI Intake Download Brief",
        [Analytics.AI_INTAKE_OPEN]: "AI Intake Opened",
        [Analytics.AI_INTAKE_RESET_BRIEF]: "AI Intake Reset Brief",
        [Analytics.AI_INTAKE_CREATE_PROJECT]: "AI Intake Create Project",
        [Analytics.AI_INTAKE_CREATE_BID]: "AI Intake Create Bid",
    };

    static gtag(...args) {
        if (
            typeof window !== "undefined" &&
            typeof window.gtag === "function"
        ) {
            window.gtag(...args);
        }
    }

    static trackEngagement(event) {
        Analytics.gtag("event", event, {
            event_category: "engagement",
            event_label: Analytics.labels[event] || "",
        });
    }

    static trackUserInfo({ subscription }) {
        Analytics.gtag("set", {
            user_properties: { subscription_type: subscription },
        });
    }
}
